const ChatToVoice = () => {
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2376_1387)">
        <path
          d="M0 15.1251V8.90381C0 8.2188 0.542528 7.67627 1.19877 7.67627H1.94132C2.59756 7.67627 3.14008 8.2188 3.14008 8.90381V15.1251C3.14008 15.7813 2.59756 16.3238 1.94132 16.3238H1.19877C0.542528 16.3238 0 15.7813 0 15.1251Z"
          fill="#5F80F8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.87891 18.9488V5.05131C5.87891 4.39507 6.4502 3.85254 7.10644 3.85254H7.82022C8.50523 3.85254 9.04776 4.39507 9.04776 5.05131V18.9488C9.04776 19.6338 8.50523 20.1763 7.82022 20.1763H7.10644C6.4502 20.1763 5.87891 19.6338 5.87891 18.9488Z"
          fill="#5F80F8"
        />
        <path
          d="M11.7871 22.8012V1.22754C11.7871 0.542528 12.3296 0 12.9859 0H13.7284C14.3847 0 14.9272 0.542528 14.9272 1.22754V22.8012C14.9272 23.4575 14.3847 24 13.7284 24H12.9859C12.3296 24 11.7871 23.4575 11.7871 22.8012Z"
          fill="#5F80F8"
        />
        <path
          d="M26.7104 15.1251V8.90381C26.7104 8.2188 26.1679 7.67627 25.4829 7.67627H24.7691C24.1128 7.67627 23.5703 8.2188 23.5703 8.90381V15.1251C23.5703 15.7813 24.1128 16.3238 24.7691 16.3238H25.4829C26.1679 16.3238 26.7104 15.7813 26.7104 15.1251Z"
          fill="#5F80F8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8041 18.9488V5.05131C20.8041 4.39507 20.2616 3.85254 19.6054 3.85254H18.8916C18.2066 3.85254 17.6641 4.39507 17.6641 5.05131V18.9488C17.6641 19.6338 18.2066 20.1763 18.8916 20.1763H19.6054C20.2616 20.1763 20.8041 19.6338 20.8041 18.9488Z"
          fill="#5F80F8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2376_1387">
          <rect width="26.7099" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChatToVoice;
